/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Lower extends React.Component {
  render() {
    return <div>
        {this.props.children}
    </div>
  }
};
export default Lower;


// WEBPACK FOOTER //
// ./src/routes/lower/index.js